import { SearchInputsSchema } from "../models";

export const searchSliderMinMaxValues = {
  ageMinMax: [18, 99],
  heightMinMax: [130, 230],
  weightMinMax: [35, 150],
} satisfies Record<string, [number, number]>;

export const searchInputsSchemaDefaults: Required<SearchInputsSchema> = {
  Id: "",
  age: searchSliderMinMaxValues.ageMinMax,
  height: searchSliderMinMaxValues.heightMinMax,
  weight: searchSliderMinMaxValues.weightMinMax,
  hasIntroVideo: false,
  online: false,
  hasVideo: false,
  ladiesWithCam: false,
  birthdaySoon: false,
  newest: false,
  topLadies: false,
  country: "",
  children: "",
  city: "",
  drinking: "",
  englishSkill: "",
  eyeColor: "",
  hairColor: "",
  appearanceType: "",
  religion: "",
  smoking: "",
  zodiacSign: "",
};
